import React from "react";
import { useTranslation } from "react-i18next";
import {
  useActivateProjectResource,
  useResourceRetrieval,
} from "@planzone/view-models";
import { ProjectResource } from "@planzone/dto";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { WorkspaceContext } from "@scenes/workspaceContext";
import { Safeguard } from "@scenes/safeguard";
import { UseCases } from "@planzone/core";
import { Props } from "./types";
import { InfoResource } from "./infoResource";
import styles from "./styles.scss";

function ProjectResourceActivation({ projectResource, cancel }: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending: isResourceRetrievalPending,
    isRequestSuccess,
    isRequestFailure,
    resource,
    retrieveResource,
  } = useResourceRetrieval(projectResource.resource.uuid);
  const { isRequestPending, activateProjectResource } =
    useActivateProjectResource(projectResource);
  const [formData, setFormData] =
    React.useState<ProjectResource>(projectResource);

  React.useEffect(() => {
    !isResourceRetrievalPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveResource(projectResource.resource.uuid);
  }, [projectResource.resource.uuid]);

  React.useEffect(() => {
    setFormData(projectResource);
  }, [projectResource]);

  return (
    <WorkspaceContext type="project" project={projectResource.project}>
      <Modal header={t("activateProjectResource.title")} close={cancel}>
        <Safeguard useCases={[UseCases.activateProjectResource]}>
          {({ canActivateProjectResource }) => (
            <div className={styles.projectResourceActivaton}>
              <div className={styles.body}>
                <div className={styles.group}>
                  <p className={styles.warning}>
                    {t("activateProjectResource.warning")}
                  </p>
                </div>
                <InfoResource
                  resource={
                    isRequestSuccess ? resource : projectResource.resource
                  }
                />
              </div>
              {canActivateProjectResource && (
                <div className={styles.footer}>
                  <Button type="cancel" press={cancel}>
                    {t("activateProjectResource.cancel")}
                  </Button>
                  <Button
                    type={"submit"}
                    status={isRequestPending ? "pending" : "none"}
                    isDisabled={isRequestPending}
                    press={() =>
                      activateProjectResource({
                        projectResource,
                        nextProjectResource: formData,
                      })
                    }
                  >
                    {t("activateProjectResource.save")}
                  </Button>
                </div>
              )}
            </div>
          )}
        </Safeguard>
      </Modal>
    </WorkspaceContext>
  );
}

export { ProjectResourceActivation };
